// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"df5b5252","206":"273bc906","239":"97a4ff99","455":"137f2a47","977":"89f41f9d"}[chunkId] + ".chunk.js";
};